import { useDispatch } from "react-redux";

import Modal from "components/Modal";
import useTranslation from "hooks/useTranslation";
import ModalBody from "components/Modal/ModalBody";
import ModalFooter from "components/Modal/ModalFooter";
import { closeAllConversationsStart } from "redux/chats/chats.actions";

function CloseConvsModal({
  showModal,
  setShowModal,
  agentId,
  removeIncomingConvs,
  setRemoveIncomingConvs,
  selectedConversations,
}) {
  const { getTranslation } = useTranslation(["CHAT", "COMMON"]);

  const { t } = getTranslation();
  const dispatch = useDispatch();

  const modalTitleOnType = {
    pending: t("MODAL").DELETE_PENDINGS_CONFIRM,
    ongoing: t("MODAL").DELETE_ONGOINGS_CONFIRM,
  };

  const modalTitle = modalTitleOnType[selectedConversations];

  const handleClickCancelBtn = () => {
    setShowModal(false);
    setRemoveIncomingConvs(false);
  };

  const handleClickConfirmBtn = () => {
    if (removeIncomingConvs) {
      dispatch(closeAllConversationsStart());
    } else {
      dispatch(closeAllConversationsStart(agentId));
    }

    setShowModal(false);
  };

  return (
    <Modal
      setVisibility={setShowModal}
      visible={showModal}
      className="confirmation-modal"
    >
      <ModalBody>
        <div>
          <div className="conv__body__header_block_user_modal_title">
            {modalTitle}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="modal__container__footer__left">
          <button
            onClick={handleClickCancelBtn}
            className="btn btn-tertiary"
            id="closeModal"
          >
            {t("CANCEL")}
          </button>
          <button onClick={handleClickConfirmBtn} className="btn btn-primary">
            {t("CONFIRM")}
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}

export default CloseConvsModal;
